import {
  MSG_DELETE_WARNING,
  MSG_UNDO_DELETE_WARNING,
  MSG_RECORD_CREATE,
  MSG_RECORD_UPDATE,
  MSG_RECORD_DELETE,
  MSG_RECORD_UNDO,
  MIN_TEXT_LENGTH,
  MAX_TEXT_LENGTH,
} from "constants/common";

//Terraform
export const METHOD_TERRAFORM_LIST = "terraform/pageable/";
export const METHOD_TERRAFORM_CREATE = "terraform/";
export const METHOD_TERRAFORM_UPDATE = "terraform/{ID}/";
export const METHOD_TERRAFORM_DELETE = "terraform/{ID}/";
export const METHOD_TERRAFORM_DETAIL = "terraform/{ID}/";


//GoLang
export const METHOD_GOLANG_LIST = "golang/pageable/";
export const METHOD_GOLANG_CREATE = "golang/";
export const METHOD_GOLANG_UPDATE = "golang/{ID}/";
export const METHOD_GOLANG_DELETE = "golang/{ID}/";
export const METHOD_GOLANG_DETAIL = "golang/{ID}/";

//vsp-one-block-terraform-provider
export const METHOD_VSP_ONE_BLOCK_TERRAFORM_PROVIDER_LIST = "vsponeblockterraformprovider/pageable/";
export const METHOD_VSP_ONE_BLOCK_TERRAFORM_PROVIDER_CREATE = "vsponeblockterraformprovider/";
export const METHOD_VSP_ONE_BLOCK_TERRAFORM_PROVIDER_UPDATE = "vsponeblockterraformprovider/{ID}/";
export const METHOD_VSP_ONE_BLOCK_TERRAFORM_PROVIDER_DELETE = "vsponeblockterraformprovider/{ID}/";
export const METHOD_VSP_ONE_BLOCK_TERRAFORM_PROVIDER_DETAIL = "vsponeblockterraformprovider/{ID}/";

//text box length
export const TEXT_MIN_LENGTH = MIN_TEXT_LENGTH;
export const TEXT_MAX_LENGTH = MAX_TEXT_LENGTH;

//language constants
export const MSG_WARNING_DELETE = MSG_DELETE_WARNING;
export const MSG_WARNING_UNDO_DELETE = MSG_UNDO_DELETE_WARNING;
export const MSG_CREATE_RECORD = MSG_RECORD_CREATE;
export const MSG_UPDATE_RECORD = MSG_RECORD_UPDATE;
export const MSG_DELETE_RECORD = MSG_RECORD_DELETE;
export const MSG_UNDO_RECORD = MSG_RECORD_UNDO;

// generic error template

export const MSG_COMBINE_KEY_WARNING =
  "Please select at least one combine key from the dropdown!";
export const MSG_MAPPING_DELETE_WARNING = "Are you sure you want to remove ";
export const MSG_MAPPING_RESTORE_WARNING = "Are you sure you want to restore ";
export const MAPPING_SELECT_ERROR_TEMPLATE = "Please select _FIELD_NAME_!";
export const MAPPING_INPUT_ERROR_TEMPLATE = "Please enter _FIELD_NAME_!";